import styled from 'styled-components';
import { Avatar } from '@components/Avatar';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace, themeColor } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const StyledPrivacyControlsContainer = styled(Flex)`
  max-width: 45.0625rem;
`;

export const StyledPasswordImage = styled.div`
  width: 50%;
  height: 348px;
  margin-left: auto;
  margin-right: auto;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: unset;
    text-align: center;
  }
`;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 289px;
    ${themeMediaQuery('sm')} {
      max-width: 451px;
    }
  }
  .text-pairing-title {
    max-width: 350px;
    white-space: pre-wrap;
    ${themeMediaQuery('sm')} {
      white-space: normal;
    }
    ${themeMediaQuery('xl')} {
      max-width: 470px;
    }
  }
`;

export const StyledAvatarContainer = styled(Box)`
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    text-align: end;
  }
`;

export const AvatarFormCloud = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    margin-right: ${themeSpace(-4)};
  }
`;

export const ProtectionCloud = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const StyledPasswordContainer = styled(Flex)`
  margin-top: 124px;
  width: 61%;
  max-width: 990px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 256px;

  ${themeMediaQuery('below_sm')} {
    margin-bottom: 96px;
    width: 100%;
    align-items: flex-start;
  }
`;

export const StyledPrivateEventsContainer = styled(Flex)`
  max-width: 990px;
  width: 61%;
  margin-right: auto;
  margin-left: auto;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    align-items: flex-start;
  }
`;

export const StyledTopLeftAvatar = styled(Avatar)`
  position: relative;
  top: 143px;
  left: 20%;
  ${themeMediaQuery('below_sm')} {
    top: 105px;
    left: -70%;
  }
`;

export const StyledTopRightAvatar = styled(Avatar)`
  position: relative;
  left: 36%;
  bottom: -15px;
  ${themeMediaQuery('below_sm')} {
    left: -25%;
  }
`;

export const StyledBottomLeftAvatar = styled(Avatar)`
  position: relative;
  bottom: 70px;
  right: 34px;
  ${themeMediaQuery('below_sm')} {
    bottom: 42px;
    right: 85%;
  }
`;

export const StyledBottomRightAvatar = styled(Avatar)`
  position: relative;
  bottom: 134px;
  left: 38%;
  ${themeMediaQuery('below_sm')} {
    bottom: 91px;
    left: -35%;
  }
`;

export const TextPairingWrapper = styled(Box)`
  width: 50%;
  max-width: 447px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    max-width: 100%;
  }
`;

export const DetailTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 312px;
  }
  .text-pairing-title {
    max-width: 312px;
  }
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    .text-pairing-title {
      max-width: 100%;
      text-align: center;
    }
    .text-pairing-body {
      max-width: 100%;
      text-align: center;
    }
  }
`;

export const ColumnContainer = styled(Columns)`
  max-width: 100%;
  margin: ${themeSpace(0)};
  width: 100%;
  z-index: 2;
  position: relative;
  background-color: ${themeColor('neutra6')};
`;

export const ColumnContent = styled(Columns.Column)`
  margin: ${themeSpace(0)};
`;
